import { ActionContext } from 'vuex';
import LanguageService from '@/app/common/service/LanguageService';
import StorageRepository from '@/app/common/repository/StorageRepository';
import LicenseService from '@/app/common/service/LicenseService';
import ApiService from '@/app/common/service/ApiService';
import IRootState from '@/app/common/model/IRootState';
import ILicense from '@/app/common/model/ILicense';

const actions = {
  async translate(context: ActionContext<IRootState, IRootState>) {
    try {
      const languageList = await LanguageService.getLanguageList();
      const shortcut = StorageRepository.getCurrentLang();
      if (shortcut) {
        await context.dispatch('setTranslation', shortcut.toLowerCase());
      } else {
        const currentLang = languageList[0].shortcut;
        await context.dispatch('setTranslation', currentLang.toLowerCase());
      }
      context.commit('setLanguages', languageList);
    } catch (e) {
      throw e;
    }
  },
  async setTranslation(
    context: ActionContext<IRootState, IRootState>,
    shortcut: string,
  ) {
    context.commit('setTranslations', {
      translations: await LanguageService.getPublicTranslations(shortcut),
      shortcut: shortcut.toLowerCase(),
    });
    StorageRepository.setCurrentLang(shortcut);
  },
  async getLicense(context: ActionContext<IRootState, IRootState>) {
    const license = StorageRepository.getLicense();
    if (!StorageRepository.isLicenseAndRecaptchaCached()) {
      try {
        const response: ILicense = await LicenseService.getLicense();
        StorageRepository.saveLicense(response.license);
        StorageRepository.saveRecaptcha(response.reCaptcha);
        ApiService.setHeader('License', `License ${response.license}`);
        context.commit('saveLicense', response);
        if (response.license) {
          await context.dispatch('getUserSettings');
          await context.dispatch('getImagesSettings');
          await context.dispatch('getMenuLogo');
        }
      } catch (e) {
        throw e;
      }
    } else {
      ApiService.setHeader('License', `License ${license}`);
      context.commit('saveLicense', {license: StorageRepository.getLicense(), reCaptcha: StorageRepository.getRecaptcha()});
      await context.dispatch('getUserSettings');
      await context.dispatch('getImagesSettings');
      await context.dispatch('getMenuLogo');
    }
  },
  async getImagesSettings(context: ActionContext<IRootState, IRootState>) {
    context.commit('setImages', await LicenseService.getImagesSettings());
  },
  async getMenuLogo(context: ActionContext<IRootState, IRootState>) {
    context.commit('setMenuLogo', await LicenseService.getMenuLogo());
  },
  async getUserSettings(context: ActionContext<IRootState, IRootState>) {
    context.commit('setUserSettings', await LicenseService.getUserSettings());
  },
};

export default actions;
